<!-- =========================================================================================
    File Name: UserSubscriptionPopup.vue
    Description: User Subscription details
========================================================================================== -->
<template>
<div>
  <vs-popup :title="$t('STEP 1')" :active.sync="isDeviceChangePopupActiveLocal">
      <p class="font-bold">⚠️{{this.$t('BEFORE_REPLACE_DEVICE_MESSAGE')}} </p>
    <vs-list v-if="userInfo.device.deviceUUID !== '' ">
      <vs-list-header icon-pack="feather" icon="icon-shuffle" :title="$t('BEFORE_CHANGE_INFO')"></vs-list-header>

          <vs-list-item :title="$t('USER_ID')" >
              <p class="text-danger"> {{userInfo.user.userId}} </p>
          </vs-list-item>

          <vs-list-item :title="$t('EMAIL')" >
              {{userInfo.user.email}}
          </vs-list-item>

          <vs-list-item :title="$t('DEVICE_UUID')" >
            <p class="text-danger font-bold"> {{userInfo.device.deviceUUID}} </p>
          </vs-list-item>

          <vs-list-item :title="$t('DEVICE_STATUS')" >
            <vs-chip :color="getDeviceStatusColor(userInfo.device.deviceStatus)">
              {{$t(setDeviceStatusName(userInfo.device.deviceStatus))}}
            </vs-chip>
          </vs-list-item>

          <vs-list-item :title="$t('SERVICE_STATUS')" >
            <vs-chip :color="getServiceStatusColor(userInfo.device.serviceStatus)">
              {{$t(setServiceStatusName(userInfo.device.serviceStatus))}}
            </vs-chip>
          </vs-list-item>

          <vs-list-item :title="$t('USED_SUBSCRIBE_STATUS')" >
            <vs-chip :color="getUsedSubscribeColor(userInfo.device.usedSubscribe)">
              {{$t(setUsedSubscribeName(userInfo.device.usedSubscribe))}}
            </vs-chip>
          </vs-list-item>

          
          <vs-list-item :title="$t('LAST_CONNECTED_TIME')" >
            {{setLocalTime(userInfo.device.lastConnectedTime)}}
          </vs-list-item>

          <vs-list-item :title="$t('PROMOTION_START_DATETIME')" >
            {{setLocalTime(userInfo.device.promotionStartDateTime)}}
          </vs-list-item>

    </vs-list>

    <vs-divider/>

    <div class="float-right">
      <vs-button color="primary" @click="popupStep2=true">{{$t('NEXT')}}</vs-button>
      <vs-button type="border" class="ml-5" color="danger" @click.stop="isDeviceChangePopupActiveLocal = false">{{$t('CLOSE')}}</vs-button>

      <vs-popup scrollable title="STEP 2" :active.sync="popupStep2ActiveLocal">
        <p class="font-bold">⚠️ {{this.$t('SELECT_REPLACE_DEVICE_MESSAGE')}}</p>
        <br/>
        <div style="height:300px;">
          <v-select
            v-model="selected"
            label="deviceUUID"
            :options="deviceOption"
          />
          <div v-if="replaceDeviceInfo.deviceUUID !== ''" >
            <vs-divider/>
                <vs-list>
                    <vs-list-header icon-pack="feather" icon="icon-shuffle" :title="$t('REPLACE_DEVICE_INFO')"></vs-list-header>
                      <vs-list-item :title="$t('DEVICE_UUID')" >
                        <p class="text-danger font-bold"> {{replaceDeviceInfo.deviceUUID}} </p>
                      </vs-list-item>

                      <vs-list-item :title="$t('DEVICE_STATUS')" >
                        <vs-chip :color="getDeviceStatusColor(replaceDeviceInfo.deviceStatus)">
                          {{$t(setDeviceStatusName(replaceDeviceInfo.deviceStatus))}}
                        </vs-chip>
                      </vs-list-item>

                      <vs-list-item :title="$t('SERVICE_STATUS')" >
                        <vs-chip :color="getServiceStatusColor(replaceDeviceInfo.serviceStatus)">
                          {{$t(setServiceStatusName(replaceDeviceInfo.serviceStatus))}}
                        </vs-chip>
                      </vs-list-item>

                      <vs-list-item :title="$t('USED_SUBSCRIBE_STATUS')" >
                        <vs-chip :color="getUsedSubscribeColor(replaceDeviceInfo.usedSubscribe)">
                          {{$t(setUsedSubscribeName(replaceDeviceInfo.usedSubscribe))}}
                        </vs-chip>
                      </vs-list-item>

                      <vs-list-item :title="$t('LAST_CONNECTED_TIME')" >
                        {{setLocalTime(replaceDeviceInfo.lastConnectedTime)}}
                      </vs-list-item>

                       <vs-list-item :title="$t('PROMOTION_START_DATETIME')" >
                        {{setLocalTime(replaceDeviceInfo.promotionStartDateTime)}}
                      </vs-list-item>
                </vs-list>
          </div>
        </div>

        <br/>
        <vs-divider/>
        <div class="float-right">
        <vs-button color="primary" type="border" @click="popupStep2=false">{{$t('BEFORE')}}</vs-button>
        <vs-button class="ml-5" color="primary" @click="popupStep3=true" :disabled="!validateForm">{{$t('NEXT')}}</vs-button>
        </div>
          <vs-popup title="STEP 3" :active.sync="popupStep3ActiveLocal">
            <p class="font-bold">⚠️{{this.$t('LAST_CHECK_TO_REPLACE_DEVICE_MESSAGE')}}</p>
            <p class="font-bold"> {{this.$t('REPLACE_DEVICE_MESSAGE')}}</p>
            <div class="mt-4">
            <vs-table v-if="userInfo.device.deviceUUID !== ''" :data="userInfo.device">
              <template slot="thead">
                <vs-th>{{this.$t('ITEM')}}</vs-th>
                <vs-th>{{this.$t('CURRENT_DEVICE')}}</vs-th>
                <vs-th></vs-th>
                <vs-th>{{this.$t('CHANGE_DEVICE')}}</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr>
                  <vs-td>
                    <span>{{$t('DEVICE_UUID')}}</span>
                  </vs-td>
                  <vs-td>
                    <p class="text-danger font-bold"> {{data.deviceUUID}} </p>
                  </vs-td>
                  <vs-td>
                     <span><i class="material-icons">arrow_right</i></span>
                  </vs-td>
                  <vs-td>
                     <p class="text-danger font-bold"> {{replaceDeviceInfo.deviceUUID}} </p>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-divider/>
            <div class="float-right">
              <vs-button color="primary" type="border" @click="popupStep3=false">{{$t('BEFORE')}}</vs-button>
              <vs-button class="ml-5" color="primary" @click="replaceDevice()">{{$t('REPLACE')}}</vs-button>
            </div>
          </div>
          </vs-popup>
      </vs-popup>
    </div>
  </vs-popup>
</div>
</template>

<script>

import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  data() {
    return {
      popupStep2: false,
      popupStep3: false,
      selected: '',
    }
  },
  props: {
    isDeviceChangePopupActive: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    userInfo(){
      return this.$store.state.dataUser.selectedUser
    },
    deviceOption(){
      return this.$store.state.dataUser.userlessDevices
    },
    isDeviceChangePopupActiveLocal: {
      get() {
        return this.isDeviceChangePopupActive
      },
      set(val) {
        this.selected = ""
        if (!val) {
          this.$emit('close')
        }
      }
    },
    popupStep2ActiveLocal: {
      get() {
        return this.popupStep2
      },
      set(val) {
        this.selected = ""
        if (!val) {
          this.popupStep2 = false
        }
      }
    },
    popupStep3ActiveLocal:{
      get() {
        return this.popupStep3
      },
      set(val) {
        if (!val) {
          this.popupStep3 = false
        }
      }
    },
    replaceDeviceInfo(){
      return this.$store.state.dataUser.replaceDeviceInfo
    },
    validateForm() {
      return !this.errors.any() && this.replaceDeviceInfo.deviceUUID !== ''
    },
  },
  created() {
    this.$store.dispatch("dataUser/fetchUserlessDevice")
  },
  watch:{
    selected: function(val){

      if(val === null || val === ""){
        val = ""
        this.$store.commit('dataUser/RESET_DEVICE_INFO')
      }else{
        this.$vs.loading()

        this.$store.dispatch("dataUser/fetchDevice",this.selected.deviceUUID)
        .then((response) => {
          this.$vs.loading.close()
        })
        .catch((error) => {
          this.$vs.loading.close()
          console.log(error)
        })
      }
      
    }
  },
  methods: {
    getDeviceStatusColor(status) {
      if (status === "" ) return "primary" 
      return this.$store.state.commonConfig.deviceStatus.properties[status].color
    },
    setDeviceStatusName(status){
      if (status === "") return ""
      return this.$store.state.commonConfig.deviceStatus.properties[status].name
    },
    getServiceStatusColor(status) {
      if (status === "") return "primary"
      return this.$store.state.commonConfig.serviceStatus.properties[status].color
    },
    setServiceStatusName(status){
      if (status === "") return ""
      return this.$store.state.commonConfig.serviceStatus.properties[status].name
    },
    getUsedSubscribeColor(status) {
      if (status === "") return "primary"
      return this.$store.state.commonConfig.usedSubscriptionStatus.properties[status].color
    },
    setUsedSubscribeName(status){
      if (status === "") return ""
      return this.$store.state.commonConfig.usedSubscriptionStatus.properties[status].name
    },
    setLocalTime(time){
      if(!time){
        return '-'
      }else {
        let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        let dateTime = this.$moment(time,'YYYYMMDDHHmmss').format()
        let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')
          
        return dateTimeToLocal
      }
    },
    replaceDevice(){
      this.$vs.loading()

      let replaceDevice = {
        userUUID : this.userInfo.user.uuid,
        replaceDeviceUUID : this.replaceDeviceInfo.deviceUUID
      }

      this.$store.dispatch("dataUser/replaceDevice", replaceDevice)
      .then(() => {
        this.close()
        this.successAlert(this.$t("SUCCESS"),this.$t("REPLACE_DEVICE_SUCCESS"))
      })
      .catch(error => { 
        this.errorAlert(this.$t("ERROR"), error.message)
        this.$vs.loading.close()
      })
    },
    close(){
      this.popupStep3 = false
      this.popupStep2 = false
      this.isDeviceChangePopupActiveLocal = false
      this.$vs.loading.close()
      this.$parent.$refs.userTable.getData()
    }
  }
}

</script>

<style scoped>
.subscription-progress{
  width: 250px;
}
</style>